import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import HeaderBar from "./common/HeaderBar";
import FooterBar from "./common/FooterBar";
import Lock from "../icon/Lock";
import RemoveIcon from "../icon/RemoveIcon";
import "../style/cart.scss";
import { useSelector, useDispatch } from "react-redux";
import { removeItem } from "../store/cartSlice";
import { routeToPage } from "../util/RouteToPage";
import PagePath from "../util/RoutePagePath";
import Number from "./common/Number";
import { currency } from "./common/Common";

const Cart = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const cartItems = useSelector((state) => state.cart.cartItems);
  const total = cartItems.reduce(
    (sum, item) => sum + item.total * item.quantity,
    0,
  );

  const removeItemFormCart = (id) => {
    dispatch(removeItem(id));
  };

  return (
    <React.Fragment>
      <HeaderBar />

      <div className="min-h-screen bg-[#fafafa]">
        <div className="mx-auto max-w-[1400px] px-6 py-20">
          {/* title */}
          <div className="mb-16 flex items-end justify-between">
            <div>
              <p className="mb-3 text-xs uppercase tracking-[6px] text-neutral-400">
                Shopping Bag
              </p>

              <h1 className="text-6xl font-extralight">Cart</h1>
            </div>

            <div className="text-sm text-neutral-500">
              {cartItems.length} Items
            </div>
          </div>

          {cartItems.length > 0 ? (
            <div className="grid gap-0 lg:grid-cols-[1fr_420px]">
              {/* products */}
              <div className="border border-neutral-200 bg-white">
                {cartItems.map((item, index) => (
                  <div
                    key={index}
                    className="grid grid-cols-[140px_1fr_auto] gap-8 border-b border-neutral-100 p-8 last:border-b-0"
                  >
                    {/* image */}
                    <div className="overflow-hidden bg-neutral-100">
                      <img
                        src={item?.image?.[0]}
                        alt=""
                        className="h-[160px] w-full object-cover"
                      />
                    </div>

                    {/* info */}
                    <div className="flex flex-col justify-between">
                      <div>
                        <h3 className="text-lg font-medium">{item.title}</h3>

                        <p className="mt-2 text-sm text-neutral-500">
                          Premium Collection
                        </p>
                      </div>

                      <div className="flex items-center gap-4">
                        <div className="border border-neutral-300 px-4 py-2">
                          <Number id={item.id} num={item.quantity} />
                        </div>

                        <button
                          onClick={() => removeItemFormCart(item.id)}
                          className="text-xs uppercase tracking-[2px] text-neutral-400 hover:text-red-500"
                        >
                          Remove
                        </button>
                      </div>
                    </div>

                    {/* price */}
                    <div className="flex items-start">
                      <div className="text-xl font-light">
                        {currency}
                        {item?.total?.toFixed(2)}
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* summary */}
              <div className="p-10">
                <p className="text-xs uppercase tracking-[4px] text-neutral-400">
                  Order Summary
                </p>

                <div className="mt-10">
                  <div className="text-sm text-neutral-400">Total Amount</div>

                  <div className="mt-3 text-6xl font-extralight">
                    {currency}
                    {total.toFixed(2)}
                  </div>
                </div>

                <div className="mt-14 space-y-5 border-t border-white/10 pt-8">
                  <div className="flex justify-between">
                    <span className="text-neutral-400">Subtotal</span>

                    <span>
                      {currency}
                      {total.toFixed(2)}
                    </span>
                  </div>

                  <div className="flex justify-between">
                    <span className="text-neutral-400">Delivery</span>

                    <span>Free</span>
                  </div>

                  <div className="flex justify-between">
                    <span className="text-neutral-400">Tax</span>

                    <span>Included</span>
                  </div>
                </div>

                <button
                  onClick={() => routeToPage(navigate, PagePath.CHECKOUT_PAGE)}
                  className="mt-14 w-full border border-white py-4 text-sm uppercase tracking-[4px] transition hover:bg-white hover:text-black"
                >
                  Checkout
                </button>

                <button
                  onClick={() => routeToPage(navigate, PagePath.HOME_PAGE)}
                  className="mt-4 w-full text-center text-sm text-neutral-400"
                >
                  Continue Shopping
                </button>
              </div>
            </div>
          ) : (
            <div className="flex min-h-[500px] flex-col items-center justify-center">
              <h2 className="text-5xl font-extralight">Your Cart Is Empty</h2>

              <p className="mt-4 text-neutral-500">
                Explore our latest collection.
              </p>

              <button
                onClick={() => routeToPage(navigate, PagePath.HOME_PAGE)}
                className="mt-10 border border-black px-10 py-4 text-xs uppercase tracking-[4px] hover:bg-black hover:text-white"
              >
                Shop Now
              </button>
            </div>
          )}
        </div>
      </div>

      <FooterBar />
    </React.Fragment>
  );
};

export default Cart;
